import React from 'react';
import DoubleActionWithError from '../../../../../FormComponents/DoubleActionWithError';
import { Footer } from '../../../../../../libs/gs-component-right-rail';

interface DesignRailBottomButtonBarProps {
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  showErrorToast: boolean;
  isPublished: boolean;
}

const DesignRailBottomButtonBar = ({
  onSave,
  onCancel,
  isLoading,
  showErrorToast,
  isPublished,
}: DesignRailBottomButtonBarProps) => {
  return (
    <Footer>
      <div data-testid="previewRightRailFooter">
        <DoubleActionWithError
          isPublished={isPublished}
          primaryOnClick={onSave}
          secondaryOnClick={onCancel}
          errorText={'Something went wrong! Your website has not been updated.'}
          showSpinner={isLoading}
          showError={showErrorToast}
          secondaryText="Cancel"
        />
      </div>
    </Footer>
  );
};

export default DesignRailBottomButtonBar;
